import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* subscriptionDelete(action: ActionInterface): any {
  try {

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_DELETE_REQUEST
    });

    yield call(Http.delete, `subscription/${action.payload?.subscription.id}`);

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_DELETE_SUCCESS,
      payload: {
        subscribe: action.payload?.subscribe,
        subscription: action.payload?.subscription
      }
    });

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_DELETE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchSubscriptionDelete() {
  yield takeEvery(Constants.GLOBAL_SUBSCRIPTION_DELETE_START, subscriptionDelete);
}
